/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

//import axios from '@/axios.js';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
//import router from '@/router';
import moment from "moment-timezone";
import _ from 'lodash';
import axios from 'axios';
export default {
  // addItem({ commit }, item) {
  //   return new Promise((resolve, reject) => {
  //     axios.post("/api/data-list/products/", {item: item})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, {id: response.data.id}))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  
  /*saveData ({state}) {
    const user = _.clone(state.user)
    const emailKey = user.email.toString().replace(/\./g, '||')
    if(user.edit && user.password === '') {
      delete user.password
    }
    if(user.company === undefined) {
      user.company = '--TEST--'
    }
    return new Promise(async (resolve, reject) => {
      if(user.avatar_path.substring(0,5) === 'https'){
        user.avatar_path = null
        user.edit = null
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
        
      }else{
        user.avatar_path = null
        await firebase.storage().ref().child(`users/${user.email}`).put(user.avatar).then(() => {
          user.avatar = `https://firebasestorage.googleapis.com/v0/b/oktallentdb.appspot.com/o/users%2F${user.email}?alt=media`;
        });
        firebase.database().ref(`/users/${emailKey}`).set(user).then(()=> {
          resolve(`${user.firstname} ${user.lastname}`)
        }).catch((error) => { reject(error) })
      }
    })
  },*/
  async updateStatusBack({rootState,state}){
    const statementUser = state.statementUser;
    firebase.firestore().collection("krungsri").doc(statementUser.key).get().then((result)=>{
      if(result.data().status === rootState.AppActiveUser.email){
        firebase.firestore().collection("krungsri").doc(statementUser.key).update({
          status:'กำลังดำเนินการ'
        });
      }
    });
  },
  async updateStatus2({state,rootState,commit},status){
    const data = state.selected;
    if(data.key){
      firebase.firestore().collection("krungsri").doc(data.key).update({
        status,
        updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        employee:rootState.AppActiveUser,
      });
    }
    commit('SET_POPUP3',false);
  },
  async updateStatus({rootState},data){
    firebase.firestore().collection("krungsri").doc(data.key).update({
      status:rootState.AppActiveUser.email,
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
    });
  },
  async addStateMent({ rootState },{userId,qty}){
    const users = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(userId.userId).once('value')).val();
    const user = users[Object.keys(users)[0]];
    await firebase.firestore().collection("krungsri").add({
      status:'กำลังดำเนินการ',
      type:'ฝาก',
      createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      date:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
      qty,
      userId:userId.userId,
      user,
      accountno:user.account_no,
      bank:user.bank,
      truewallet:true,
      employeeCreated:true,
    });
  },
  async updateStatement({ state,commit,rootState },{selected,bonus}){
    const users = state.users;
    const statementUser = state.statementUser;
    let credit = Math.floor(statementUser.qty.toString().replace(',',''));
    if(bonus){
      let b = Math.floor(bonus.toString().replace(',',''));
      credit = Number(credit)+Number(b);
    }
    await firebase.firestore().collection("history").doc(users[selected].key).update({
      status:'loading...',
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
      bonus,
    });
    await firebase.firestore().collection("krungsri").doc(statementUser.key).update({
      status:'loading...',
      updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      employee:rootState.AppActiveUser,
      bonus,
      userId:users[selected].userId
    });
    axios({
      method: "post",
      url: "https://api.superpgslot.com/addcredit",
      data: {
        userId: users[selected].userId,
        credit
      }
    }).then(async response => {
      if (response.data && response.data.status) {
        firebase.firestore().collection("history").doc(users[selected].key).update({
          status:'ดำเนินการแล้ว',
          bonus: (response.data.bonus)?response.data.bonus:0,
          bonustoday: (response.data.bonustoday)?response.data.bonustoday:firebase.firestore.FieldValue.delete(),
        });
        firebase.firestore().collection("krungsri").doc(statementUser.key).update({
          status:'ดำเนินการแล้ว',
          bonus: (response.data.bonus)?response.data.bonus:0,
          bonustoday: (response.data.bonustoday)?response.data.bonustoday:firebase.firestore.FieldValue.delete(),
        });
      }else{
        firebase.firestore().collection("history").doc(users[selected].key).update({
          status:'กำลังดำเนินการ',
          updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          employee:rootState.AppActiveUser,
        });
        firebase.firestore().collection("krungsri").doc(statementUser.key).update({
          status:'ไม่สามารถเพิ่ม credit ได้',
          updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          employee:rootState.AppActiveUser,
        });
      }
    })
    .catch(function() {
      firebase.firestore().collection("history").doc(users[selected].key).update({
        status:'กำลังดำเนินการ',
        updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        employee:rootState.AppActiveUser,
      });
      firebase.firestore().collection("krungsri").doc(statementUser.key).update({
        status:'ไม่สามารถเพิ่ม credit ได้',
        updatetime:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        employee:rootState.AppActiveUser,
      });
    });
    commit('SET_POPUP',false);
  },
  async fetchUsers({ commit },statement) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
    }
    commit('SET_STATEMENT_USER',statement);
    if(statement.userId){
      firebase.firestore().collection("history").where("type", "==", "ฝาก").where('userId','==',statement.userId).where('status','==','กำลังดำเนินการ').orderBy('createdate','desc').get().then((query)=>{
        const statements = [];
        query.forEach((doc) => {
          const data = doc.data();
          data.key = doc.id;
            if(users[data.userId]){
              const user = users[data.userId];
              data.linename = user.linename;
              data.firstname = user.firstname;
              data.lastname = user.lastname;
              data.bank = user.bank;
              data.account_no = user.account_no;
              data.code = user.code;
              data.pictureUrl = user.pictureUrl;
            }
          statements.push(data);
        });
        commit('SET_USERS', statements);
      });
    }else{
      firebase.firestore().collection("history").where("type", "==", "ฝาก").where('status','==','กำลังดำเนินการ').orderBy('createdate','desc').get().then((query)=>{
          const statements = [];
          query.forEach((doc) => {
            const data = doc.data();
            data.key = doc.id;
            if(users[data.userId]){
              const user = users[data.userId];
              data.linename = user.linename;
              data.firstname = user.firstname;
              data.lastname = user.lastname;
              data.bank = user.bank;
              data.account_no = user.account_no;
              data.code = user.code;
              data.pictureUrl = user.pictureUrl;
            }
            statements.push(data);
          });
          commit('SET_USERS', statements);
      });
    }
    
  },
  async fetchStatement ({ commit,state }) {
    const _users = (await firebase.database().ref(`/users`).once('value')).val();
    const users = [];
    for(const x in _users){
      users[_users[x].userId] = _users[x];
      users[_users[x].userId].key = x;
    }
    let statements = (state.statement.length>0)?state.statement:[];
    firebase.firestore().collection("krungsri").where("type", "==", "ฝาก").orderBy('date','desc')
    .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const statement = change.doc.data();
            if(users[statement.userId]){
              const user = users[statement.userId];
              statement.key = change.doc.id;
              statement.user_id = user.key;
              statement.linename = user.linename;
              statement.firstname = user.firstname;
              statement.lastname = user.lastname;
              statement.bank = user.bank;
              statement.account_no = user.account_no;
              statement.code = user.code;
              statement.pictureUrl = user.pictureUrl;
              statement.createdate = statement.date;
              statements.push(statement);
            }else{
              statement.key = change.doc.id;
              statement.user_id = '';
              statement.linename = '';
              statement.firstname = '';
              statement.lastname = '';
              statement.account_no = statement.bank;
              statement.bank = '';
              statement.code = '';
              statement.pictureUrl = '';
              statement.createdate = statement.date;
              statements.push(statement);
            }
          }
          if (change.type === "modified") {
              const value = change.doc.data();
              const keyUser = _.findKey(statements, function(o) { return o.key === change.doc.id; });
              if(keyUser){
                const statement =  statements[keyUser];
                statement.qty = value.qty;
                statement.status = value.status;
                statement.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
                statement.createdate = value.date;
                statements.splice(keyUser, 1);
                statement.key = change.doc.id;
                statements.splice(keyUser, 0, statement);
              }
          }
        });
        if(statements.length > 0){
          statements = _.orderBy(statements, ['createdate'],['desc']);
          commit('SET_STATEMENT', statements);
        }
    });
    //commit('SET_USERS', []);
  },
  removeRecord({state}, key){
    for(const x in state.statement){
      if(state.statement[x].key === key){
        state.statement.splice(x, 1);
        break;
      }
    }
  }
  /*updateUsers({state,commit}, {key,value}){
    console.log(key);
    console.log(value);
    console.log(state.users);
    const users = state.users;
    const keyUser = _.findKey(users, function(o) { return o.key === key; });
    if(keyUser){
      users.splice(keyUser, 1);
      value.key = key;
      users.splice(keyUser, 0, value);
      commit('SET_USERS', users);
    }
  },*/
}
